import { App } from "./typings/App";
import { configs as configPOS } from "@eos/pos";
import { configs as configWMS } from "@eos/wms";
import { configs as configMCIM } from "@eos/mcim";
import { configs as configAdmin } from "@eos/admin";

export const apps: App[] = [configPOS(), configWMS(), configMCIM(), configAdmin()];
